import { property } from 'lodash';
import axios from 'axios';

import {
  jsonApiHeaders,
  buildApiV2Url,
  toSurveyListSearchFilter,
} from '../utils/apiUtils';
import { mapTemplateNamesListFromApiModel } from './dataMapper/templateNamesListDataMapper';
import { generateApiError } from '../utils/apiErrorMessages';
import { templateNameLoadLimit } from './config/TemplateNameLoadLimit';
import { TEMPLATE_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

const getTemplateNames = (
  search,
  offset = 0,
  limit = templateNameLoadLimit,
) => {
  const params = {
    fields: {
      survey: 'name,id',
    },
    filter: toSurveyListSearchFilter(search),
    page: {
      limit,
      offset,
    },
  };

  return axios
    .get(buildApiV2Url(TEMPLATE_TYPE_COLLECTION_PATH, params), {
      headers: jsonApiHeaders,
    })
    .catch(generateApiError())
    .then(property('data'))
    .then(mapTemplateNamesListFromApiModel);
};

export default getTemplateNames;
